const baseUrl = process.env.REACT_APP_SERVER_URL || "https://api-asa.usu.ac.id"
const appsUrl = process.env.REACT_APP_APPS_URL || "https://asa.usu.ac.id"
const uploadUrl = process.env.REACT_APP_UPLOAD_URL || "https://api-asa.usu.ac.id/upload"

module.exports = {
    baseUrl,
    appsUrl,
    uploadUrl,
}